const getMeasureKey = (key, isMeasureOnTop) => {
  const pipeSeparatedArray = key.split("|");
  const lastItemIndex = pipeSeparatedArray.length - 1;
  return isMeasureOnTop
    ? pipeSeparatedArray[0]
    : pipeSeparatedArray[lastItemIndex];
};

const QuickTableCalculation = ({
  data,
  keys,
  quickTable,
  isMeasureOnTop,
  rowTotalColumnKeys,
  isColumnTotalVisible,
  columnTotal,
}) => {
  // console.log(quickTable);
  // console.log(isColumnTotalVisible);
  const checkQuickOptions = (quickTable) => {
    if (!Array.isArray(quickTable)) {
      // console.error("quickTable is not an array:", quickTable);
      return false;
    }

    let result = true; // Assume true unless conditions are met

    quickTable.forEach((item) => {
      const { quickOption } = item;

      if (
        quickOption === "clearTableCalculation" ||
        quickOption === "noCalculation"
      ) {
        result = false; // Set to false if any item matches the condition
      }
    });

    return result;
  };

  const result = checkQuickOptions(quickTable);
  // console.log(result);

  if (!result) {
    return data;
  }
  // console.log(isMeasureOnTop);

  const firstRow = data[0];
  const nonNumericKeys = Object.keys(firstRow).filter(
    (key) => typeof firstRow[key] === "string"
  );

  const isGrandTotalPresent =
    data.length &&
    data.some((item) => Object.values(item).includes("Grand Total"));

  const grandTotalRow = isColumnTotalVisible
    ? data[data.length - 1]
    : columnTotal;

  const cumulativeTotalsForCell = {};
  const cumulativeTotalsForTotalCell = {};
  const originalData = JSON.parse(JSON.stringify(data));

  let previousObject = {};
  let runningTotal = {};
  const rowTotalColumnKeysLength = rowTotalColumnKeys.length;

  return data.map((row, rowIndex) => {
    // console.log();

    const updatedRow = { ...row };

    keys.forEach((key, columnIndex) => {
      // console.log(key);

      if (nonNumericKeys.includes(key)) return;
      const pipeSeparatedArray = key.split("|");

      if (
        cumulativeTotalsForCell[key] === undefined &&
        cumulativeTotalsForTotalCell[key] === undefined
      ) {
        cumulativeTotalsForCell[key] = 0;
        cumulativeTotalsForTotalCell[key] = 0;
      }
      // // console.log(row[`Total ${getMeasureKey(key, isMeasureOnTop)}`]);

      const requiredQuickObject = quickTable.find(
        (quickItem) =>
          quickItem.quickTableKey === getMeasureKey(key, isMeasureOnTop)
      );
      const quickOption =
        requiredQuickObject !== undefined && requiredQuickObject?.quickOption;

      const measureKey = getMeasureKey(key, isMeasureOnTop);
      const totalKey = `Total ${getMeasureKey(key, isMeasureOnTop)}`;
      let previousCumulatedValue;
      // console.log(quickOption);

      switch (quickOption) {
        case "percentageOfRowTotal":
          if (row[key] && row[totalKey]) {
            updatedRow[key] = row[key] / row[totalKey];
            updatedRow[totalKey] = row[totalKey] / row[totalKey];
          }
          break;
        case "percentageOfColumnTotal":
          const columnTotal = grandTotalRow[key];

          if (columnTotal && row[key]) {
            const colPercentage = row[key] / columnTotal;
            updatedRow[key] = colPercentage;
            // console.log(updatedRow[key]);
            // const totalKey = `Total ${getMeasureKey(key, isMeasureOnTop)}`;
            // console.log(grandTotalRow[totalKey]);
            const totalValue = row[totalKey] / grandTotalRow[totalKey];
            updatedRow[totalKey] = totalValue;
          }
          break;
        case "percentageOfGrandTotal":
          // console.log(row[key]);
          // console.log(grandTotalRow[totalKey]);
          // // console.log(row[totalKey]);
          updatedRow[key] = row[key] / grandTotalRow[totalKey];
          updatedRow[totalKey] = row[totalKey] / grandTotalRow[totalKey];
          break;
        case "runningTotalAcross":
          // console.log(previousObject);
          // // console.log(previousObject[measureKey]);
          // console.log(measureKey);
          // console.log(row);
          // // console.log(row[key]);
          // console.log(key);
          if (previousObject[measureKey]) {
            previousCumulatedValue = previousObject[measureKey];
          } else {
            previousObject[measureKey] = 0;
            previousCumulatedValue = 0;
          }
          updatedRow[key] = previousCumulatedValue + row[key];
          previousObject[measureKey] += row[key];

          // Reset the previousObject when the last column is reached to ensure independent rows
          if (columnIndex === keys.length - 1) {
            // console.log("resetting");

            previousObject = {};
          }

          break;
        case "runningTotalDown":
          // console.log("ji");

          if (isGrandTotalPresent && rowIndex === data.length - 1) {
            updatedRow[key] = row[key];
          } else {
            cumulativeTotalsForCell[key] += row[key] || 0;
            updatedRow[key] = cumulativeTotalsForCell[key];
            cumulativeTotalsForTotalCell[key] += row[totalKey];
            updatedRow[totalKey] = cumulativeTotalsForTotalCell[key];
          }
          break;
        case "tableDifferenceAcross":
          // console.log(previousObject);
          // // console.log(previousObject[measureKey]);
          // console.log(measureKey);
          // console.log(row);
          // // console.log(row[key]);
          // console.log(key);
          if (previousObject[measureKey]) {
            updatedRow[key] = row[key] - previousObject[measureKey];
            previousObject[measureKey] = row[key];
          } else {
            // console.log("setting -");

            previousObject[measureKey] = row[key];
            updatedRow[key] = "-";
          }

          if (columnIndex === keys.length - 1) {
            // console.log("resetting");

            previousObject = {};
          }

          break;
        case "tableDifferenceDown":
          if (rowIndex === 0) {
            updatedRow[key] = `-`;
            updatedRow[totalKey] = `-`;
          } else {
            const previousRow = data[rowIndex - 1];
            const previousTotalRow = data[rowIndex - 1];
            if (row[key] && previousRow[key] && previousTotalRow[totalKey]) {
              updatedRow[key] = row[key] - previousRow[key];
              updatedRow[totalKey] = row[totalKey] - previousTotalRow[totalKey];
            }
          }
          break;
        case "tableDifferenceDownPercentage":
          if (rowIndex === 0) {
            updatedRow[key] = `-`;
            updatedRow[totalKey] = `-`;
          } else {
            const previousRow = data[rowIndex - 1];
            const previousTotalRow = data[rowIndex - 1];
            if (row[key] && previousRow[key] && previousTotalRow[totalKey]) {
              updatedRow[key] =
                (row[key] - previousRow[key]) / Math.abs(previousRow[key]);
              updatedRow[totalKey] =
                (row[totalKey] - previousTotalRow[totalKey]) /
                Math.abs(previousTotalRow[totalKey]);
            }
          }
          break;
        case "tableDifferenceAcrossPercentage":
          if (previousObject[measureKey]) {
            updatedRow[key] =
              (row[key] - previousObject[measureKey]) /
              previousObject[measureKey];
            previousObject[measureKey] = row[key];
          } else {
            previousObject[measureKey] = row[key];
            updatedRow[key] = "-";
          }
          if (columnIndex === keys.length - 1) {
            // console.log("resetting");

            previousObject = {};
          }
          break;
        default:
          if (columnIndex === keys.length - 1) {
            // console.log("resetting");

            previousObject = {};
          }
          break;
      }
    });

    return updatedRow;
  });
};

export { QuickTableCalculation };
